import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'
import { OrdersType } from './OrdersType'

export function AudioField() {
  const texts = useTexts()

  const {
    field: { value: isChecked },
  } = form.useFormField('includeAudioChecked')

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()

  const formDisabled = submitting || disabled

  return (
    <>
      <form.Checkbox
        label={texts.audio}
        name="includeAudioChecked"
        validateOn="blur change"
        disabled={formDisabled}
        testId="driver-assistance-form-audio-field"
      />
      {isChecked && <OrdersType name="includeAudio" disabled={formDisabled} />}
    </>
  )
}
